export default __webpack_public_path__ + "static/media/doneIconWhite.ad4c2884.svg";